"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShadePickerEvent = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var OpenShadePicker = _interopRequireWildcard(require("@ori-events/open-shade-picker"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useShadePickerEvent = () => {
  const [shadePickerData, setShadePickerData] = (0, _react.useState)(null);
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  const onOpenShadePicker = (0, _react.useCallback)(({
    detail: {
      productName,
      products,
      placement,
      goToUrl,
      productCode,
      mode,
      productListId
    }
  }) => {
    setShadePickerData({
      mode,
      productName,
      products,
      placement,
      productCode,
      goToUrl: goToUrl ?? (0, _utils.getProductUrl)(productCode),
      productListId
    });
    onOpen();
  }, [onOpen]);
  const onCloseShadePicker = (0, _react.useCallback)(() => {
    setShadePickerData(null);
    onClose();
  }, [onClose]);
  const events = (0, _react.useMemo)(() => [{
    name: OpenShadePicker.Name,
    listener: onOpenShadePicker
  }, {
    name: BasketUpdated.Name,
    listener: onCloseShadePicker
  }], [onCloseShadePicker, onOpenShadePicker]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    data: shadePickerData,
    initialOpenDone,
    onClose,
    open
  };
};
exports.useShadePickerEvent = useShadePickerEvent;
//# sourceMappingURL=useShadePickerEvent.js.map